var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLOreal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 40,
    viewBox: "0 0 222 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.514 37.3097H149.042V33.8251H125.404V22.6747H143.159V19.1488H125.404V8.87577H149.042V5.40381H120.514V37.3097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.339 0.246094L131.477 4.58522L143.602 0.246094H135.339Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.936 33.8251V5.40381H192.477V37.3097H221.316V33.8251H196.936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.528 5.40381L151.305 37.3097H156.788L160.939 29.0515H180.396L184.582 37.3097H190.009L173.773 5.40381H167.528ZM162.992 25.0523L170.637 9.81257L178.371 25.0523H162.992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.034 23.9682C112.344 22.0178 113.054 16.5791 113.017 14.6347C112.581 8.93491 108.74 5.40381 101.84 5.40381H81.7305V37.3097H86.3147V23.9257H99.4064L109.038 37.3097H114.816C114.816 37.3097 107.885 28.3021 105.034 23.9682ZM101.214 20.1558H86.3147V9.1803H101.733C105.283 9.1803 107.28 10.8375 107.999 12.9427C108.475 14.3858 108.17 16.2801 107.383 17.5698C106.094 19.702 103.646 20.1558 101.214 20.1558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1805 0.000976562C41.2399 0.000976562 32.4199 9.12497 32.4199 20.1682C32.4199 31.7939 42.1629 40.001 54.1805 40.001C66.1901 40.001 75.9292 31.9111 75.9292 20.1682C75.9292 9.12497 67 0.000976562 54.1805 0.000976562ZM54.0252 36.0404C45.0723 36.0404 37.6956 28.8459 37.6956 20.1789C37.6956 11.5239 44.7241 3.98473 54.3723 3.98473C63.7815 3.98473 70.698 11.5239 70.698 20.1789C70.698 28.8456 62.9743 36.0404 54.0252 36.0404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.875 16.691H24.1828L30.1869 5.40381H25.3553L20.875 16.691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70373 33.8251V5.40381H0.242188V37.3097H29.081V33.8251H4.70373Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_1011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221.074,
    height: 40,
    fill: "white",
    transform: "translate(0.242188 0.000976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLOreal);
export default __webpack_public_path__ + "static/media/L_Oreal.f052aebe8b1fa45532c69b556a4b7d6e.svg";
export { ForwardRef as ReactComponent };